import React from "react";
import { useSelector } from "react-redux";
import { Table, TableHeader, HeaderColumn, TableBody, Row, Column } from "../../../../shared/components/ui/table/Table";
import TargetBadge from "../targetBadge/TargetBadge";
import Icon from "../../../../shared/components/ui/icons/Icon";
import iconsList from "../../../../shared/components/ui/icons/iconsList";
import { formatISODateDDMMYYYY } from "../../../../shared/utils/utils";
import classes from "./SystemMessagesTable.module.css";

const SystemMessagesTable = ({ messages, onEdit, onDelete }) => {
    const { texts } = useSelector(state => state.translate);

    return (
        <Table>
            <TableHeader>
                <HeaderColumn>{texts.messageTextCol}</HeaderColumn>
                <HeaderColumn>{texts.imageCol}</HeaderColumn>
                <HeaderColumn>{texts.messagePublishDate}</HeaderColumn>
                <HeaderColumn>{texts.messageEndDate}</HeaderColumn>
                <HeaderColumn>{texts.targetAudience}</HeaderColumn>
                <HeaderColumn>{texts.actions}</HeaderColumn>
            </TableHeader>
            <TableBody>
                {messages.map((msg) => (
                    <Row key={msg.id}>
                        <Column>
                            <div className={classes.MessageCell}>
                                {msg.important && <Icon name={iconsList.star} size="16px" color="#f5c518" />}
                                <span className={classes.MessageText} dangerouslySetInnerHTML={{ __html: msg.content }} />
                            </div>
                        </Column>
                        <Column>
                            {msg.imageFile && <Icon name={iconsList.checkSquare} size="20px" color="#925fe2" />}
                        </Column>
                        <Column>{formatISODateDDMMYYYY(msg.fromDate)}</Column>
                        <Column>{formatISODateDDMMYYYY(msg.toDate)}</Column>
                        <Column>
                            <TargetBadge filters={msg.messageFilters ?? []} />
                        </Column>
                        <Column>
                            <div className={classes.Actions}>
                                <Icon name={iconsList.delete} size="20px" color="#925fe2" onClick={() => onDelete(msg)} />
                                <Icon name={iconsList.editElement} size="20px" color="#925fe2" onClick={() => onEdit(msg)} />
                            </div>
                        </Column>
                    </Row>
                ))}
            </TableBody>
        </Table>
    );
};

export default SystemMessagesTable;
